import { connect } from 'react-redux';
import { IRootState } from '../../../redux/state'; // Adjust the import path if needed
import SmartMapDashboard from './smartMapDashboard';
import { bindActionCreators, Dispatch } from 'redux';
import genericMapActions from '../../../redux/modules/genericMap/genericMapActions';

const mapStateToProps = (state: IRootState) => ({
  routes: state.route.routeList,
  agreements: state.genericMapRoutes.genericMapAgreements,
  places: state.genericMapRoutes.genericMapPlaces,
  bins: state.genericMapRoutes.genericMapAgreementLines,
  routeLines: state.genericMapRoutes.genericMapRouteLines,
  highlightedMarkers: state.genericMapRoutes.highlightedMarkers,
  selectedRoutes: state.genericMapRoutes.genericMapRoutes,
  filterType: state.genericMapRoutes.filterType,
});

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    genericMapActions: bindActionCreators(genericMapActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SmartMapDashboard);
